import { __extends } from 'tslib';
import { PLAY_EVENT, LOG_TYPE, Plugin, H5Player } from '@tencent/thumbplayer-h5';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@-webkit-keyframes txp_loading{0%{background-position:0 0}to{background-position:0 -600px}}@keyframes txp_loading{0%{background-position:0 0}to{background-position:0 -600px}}.txp_overlay_loading{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;pointer-events:none}.txp_overlay_loading.txp_none,.txp_overlay_loading .txp_none{display:none}.txp_overlay_loading .txp_icon_loading{display:block;width:54px;height:20px;margin:0 auto 10px;background:url(https://vm.gtimg.cn/tencentvideo/txp/style/img/loading.png) 0 0 no-repeat;background-size:54px 600px;-webkit-animation:txp_loading 1s steps(30) infinite;animation:txp_loading 1s steps(30) infinite}.txp_overlay_loading .txp_icon_loading.mobile{-webkit-transform:scale(.5);transform:scale(.5);margin:0 auto}";
styleInject(css_248z);

var hideClass = 'txp_none';
var htmlStr = "<div class=\"txp_overlay_loading " + hideClass + "\">\n<div class=\"txp_text\" data-role=\"txp-ui-continue-play\"></div>\n<div class=\"txp_icon_loading\" data-role=\"txp-ui-loading\"></div>\n</div>";
var UILoadingPlugin = /** @class */ (function (_super) {
    __extends(UILoadingPlugin, _super);
    function UILoadingPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        /** 展示loading */
        _this.show = function (text) {
            if (text === void 0) { text = ''; }
            _this.$continuePlay.innerHTML = text;
            _this.$el.classList.remove(hideClass);
        };
        /** 隐藏loading */
        _this.hide = function () {
            _this.$el.classList.add(hideClass);
        };
        _this.insertDOM();
        // 仅监听SET_LOADING事件不监听其他事件，避免显示隐藏的逻辑混乱
        player.on(PLAY_EVENT.SET_LOADING, function (_a) {
            var data = _a.data;
            var show = data.show;
            _this.player.setStateKv("ui-loading:" + (show ? 'show' : 'hide'), {
                type: LOG_TYPE.PLUGIN_ACTION,
            });
            if (show)
                _this.show();
            else
                _this.hide();
        });
        return _this;
    }
    UILoadingPlugin.prototype.prependElement = function (el) {
        var _a;
        (_a = this.$el) === null || _a === void 0 ? void 0 : _a.insertAdjacentElement('afterbegin', el);
    };
    UILoadingPlugin.prototype.insertDOM = function () {
        var _a;
        var container = this.player.container;
        container.insertAdjacentHTML('beforeend', htmlStr);
        this.$el = container.querySelector('.txp_overlay_loading');
        this.$continuePlay = container.querySelector('[data-role="txp-ui-continue-play"]');
        this.$loading = container.querySelector('[data-role="txp-ui-loading"]');
        // 移动端loading大小是pc的一半
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.useMobileStyle)
            this.$loading.classList.add('mobile');
    };
    UILoadingPlugin.pluginName = 'ui-loading';
    return UILoadingPlugin;
}(Plugin));
H5Player.registerPlugin(UILoadingPlugin.pluginName, UILoadingPlugin);

export { UILoadingPlugin };
